<template>
    <div>
    <q-modal v-model="import_test" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '60vh'}" @hide="hideQuestionModal()" no-backdrop-dismiss no-esc-dismiss>
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-btn flat round dense @click="hideQuestionModal()" icon="fas fa-times" />
                <q-toolbar-title>
                    {{ $t('import_test') }}
                </q-toolbar-title>
            </q-toolbar>

            <div class="q-mt-sm q-pa-md">
                <div class="q-display-1 q-mb-md text-secondary">
                    <q-icon name="far fa-file-upload" class="q-mb-sm" /> {{ $t('import') }}
                </div>

                <div class="row gutter-sm q-mt-sm">
                    <div class="col-12">
                        <div class="col-12">
                            <span class="q-pr-sm">{{$t('import_test_template')}}</span>
                            <q-btn size="xl" flat round color="positive" icon="far fa-file-spreadsheet" @click="generateTemplate(1)" />
                        </div>
                        <div class="row gutter-sm">
                            <div class="col-11">
                                <p class="caption">{{ $t('file') }}</p>
                                <uploader content_type="" @fileUploaded="fileUploaded" :multiple="false" :error="$v.file_url.$error" />

                                <p v-if="file_url" class="q-mt-md file-url">
                                    <q-icon name="fal fa-check" color="positive" />
                                    <a :href="file_url" target="_blank"> {{ $truncateLink(file_url) }}</a>
                                </p>
                            </div>
                        </div>

                    </div>
                </div>

                <q-table
                    v-if="imported_test.length > 0"
                    :data="imported_test"
                    :columns="columns"
                    :loading="loading"
                    row-key="id"
                    :no-data-label="$t('no_data_avaliable')"
                    :no-results-label="$t('no_results_found')"
                    :loading-label="$t('loading_data')"
                    :rows-per-page-label="$t('items_per_page')"
                    :rows-per-page-options="[0]"
                    binary-state-sort
                    class="q-mt-lg"
                    >
                    <template slot="top" slot-scope="props" :props="props">
                        <div class="q-table-title">{{ $t('test') }}</div>
                        <div class="col" />
                    </template>

                    <q-tr slot="header" slot-scope="props" :props="props">
                        <q-th v-for="col in props.cols" :key="col.name" :props="props">
                        {{ $t(col.label) }}
                        </q-th>
                    </q-tr>

                    <q-tr slot="body" slot-scope="props" :props="props">
                        <q-td auto-width key="id" :props="props">
                            {{ props.row.id }}
                        </q-td>

                        <q-td key="question" :props="props">
                            {{ props.row.question.substring(0, 100) }}
                        </q-td>

                        <q-td key="qty_answers" :props="props">
                            {{ props.row.qty_answers }}
                        </q-td>

                        <q-td auto-width key="status" :props="props">
                            <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width">
                                {{ $t(getStatus(props.row.status)) }}
                            </q-chip>
                        </q-td>

                        <q-td auto-width key="actions" :props="props">
                            <q-btn flat round color="primary" icon="fal fa-clipboard-list-check" @click="showTestDetails()" />
                        </q-td>
                    </q-tr>
                </q-table>

                <div class="row gutter-sm q-mt-lg q-mr-md">
                    <div class="col-xs-12 col-sm-4" :class="getOrder('cancel')">
                        <q-btn color="tertiary" class="full-width" :label="$t('cancel')" icon="far fa-block" @click="hideQuestionModal()" />
                    </div>

                    <div class="col-xs-12 col-sm-4" :class="getOrder('save')">
                        <q-btn color="primary" class="full-width" :disabled="!file_url.length" :label="$t('upload_test')" icon="far fa-upload" @click="saveData()" />
                    </div>

                    <div class="col-xs-12 col-sm-4" :class="getOrder('save')" v-if="file_url_complete && imported_test.length">
                        <q-btn color="primary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveImportedTest()" />
                    </div>
                </div>
            </div>
        </q-modal-layout>
    </q-modal>

    <q-modal v-if="show_test" v-model="show_test" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '60vh'}">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_test = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('imported_test') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row gutter-sm justify-end question-list">
                        <div class="col-xs-12 col-sm-12" v-for="(question, index) in imported_test" :key="index">

                            <span :class="getQuestionClass(index, question)">
                                {{ index + 1 }}) <span v-html="question.title" class="text-bold"></span>
                            </span>
                            <q-list v-for="(answers, index) in question.answers" :key="index" dense padding style="border: none;">
                                <q-item>
                                      <q-icon :name="getAnswerIcon(answers.is_correct)" class="q-mr-sm" /> <span v-html="answers.title"></span>
                                </q-item>
                            </q-list>

                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>

    </div>
</template>

<script>
import Uploader from 'components/Uploader'
import { mapGetters } from 'vuex'
import { required, requiredIf } from 'vuelidate/lib/validators'

export default {
    props: ['id_test', 'import_test', 'has_results'],

    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 0,
                rowsPerPage: 0,
                descending: false,
                sortBy: null
            },
            loading: false,
            file_url: '',
            file_url_complete: '',
            import: false,
            show_test: false,
            original_import: [],
            imported_test: [],
            columns: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'id',
                    sortable: false,
                },
                {
                    name: 'question',
                    required: true,
                    label: 'question',
                    align: 'left',
                    field: 'question',
                    sortable: false,
                },
                {
                    name: 'qty_answers',
                    required: true,
                    label: 'alternative_quantity',
                    align: 'left',
                    field: 'qty_answers',
                    sortable: false,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: false,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'left',
                    field: 'actions',
                    sortable: false,
                }
            ],
        }
    },

    components: {
        'uploader': Uploader,
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '70vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '75vw'
        },
    },

    methods: {
        saveData() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let fd = new FormData()
                fd.append('file_url', this.file_url)
                this.$axios.post(`/admin_import/presential_event_date_tests_import/${this.id_test}/validate_archive/`, fd, this.getHeader)
                .then(response => {
                    this.imported_test = []
                    this.original_import = response.data

                    this.id = response.data.id
                    this.status = response.data.status
                    this.imported_test = response.data.map(e => {
                        return {
                                ...e,
                                id: e.id,
                                question: e.title,
                                answers: e.event_date_test_question_answers,
                                qty_answers: e.event_date_test_question_answers.length,
                                status: 1,
                                actions: e.id
                        }
                    })

                    this.$q.notify({
                        message: this.$t('test_validation_success'),
                        type: 'positive',
                        icon: 'fal fa-clipboard-list-check'
                    })

                    this.$q.loading.hide()
                })
                .catch(e => {
                    this.$q.notify({
                        message: this.$t('test_validation_error'),
                        type: 'negative',
                        icon: 'fal fa-exclamation-triangle'
                    })
                    this.file_url = ''
                    this.$q.loading.hide()
                    console.log(e)
                })
            }
            else{
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fal fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        saveImportedTest() {
            this.$q.loading.show()

            this.$axios.post(`/admin_import/presential_event_date_tests_import/${this.id_test}/start_import/`, this.original_import, this.getHeader)
            .then(response => {
                if (response.status === 200) {
                    this.$q.notify({
                        message: this.$t('test_import_success'),
                        type: 'positive',
                        icon: 'fal fa-save',
                    })
                }
                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.notify({
                        message: this.$t('test_import_error'),
                        type: 'negative',
                        icon: 'fal fa-exclamation-triangle',
                    })
                this.$q.loading.hide()
                console.log(e)
            })
            .finally(e => {
                this.hideQuestionModal()
                this.file_url = ''
                this.$v.$reset()
            })
        },

        showTestDetails() {
            this.show_test = true
        },

        generateTemplate(import_type) {
            let message = this.$t('generating_import_test_template')
            this.$q.loading.show({
                message
            })
			this.$axios.get(`/admin_import/presential_event_date_tests_import/${this.id_test}/generate_template/?import_type=${import_type}`, this.getHeader)
			.then(response => {
				this.forceFileDownload(response.data.path_url)
			})
			.catch(e => {
				console.log(e)
            })
            .finally(() =>{
                this.$q.loading.hide()
            })
        },

        forceFileDownload(response){
			const link = document.createElement('a')
			link.href = response
			document.body.appendChild(link)
			link.click()
        },

        fileUploaded(url) {
            this.file_url = url
            this.file_url_complete = url
            this.import = false
        },

        getQuestionClass(index, question) {
            let return_class = ''
            if (index != 0) return_class += 'q-mt-md'
            if (question.error) return_class += ' text-negative'
            return return_class
        },

        hideQuestionModal() {
            this.imported_test = []
            this.file_url = ''
            this.server_pagination.rowsNumber = 0
            this.$emit('returnToQuestions', '')
        },

        getStatus(status) {
            if (status == 1) return 'published_f'
            else if (status == 2) return 'unpublished_f'
            else if (status == 3) return 'deleted'
        },

        getIconStatus(status) {
            if (status == 1) return 'fas fa-check'
            else if (status == 2) return 'fas fa-ban'
            else if (status == 3) return 'fas fa-trash-alt'
        },

        getColorStatus(status) {
            if (status == 1) return 'positive'
            else if (status == 2) return 'warning'
            else if (status == 3) return 'negative'
        },

        getAnswerIcon(answer) {
            if(answer) return 'fal fa-check-square'
            else return 'fal fa-square'
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },
    },

    validations() {
        return {
            file_url: { required },
        }
    }
}
</script>

<style>

</style>
